import _toConsumableArray from "D:\\Projects\\Sledgehammer\\src\\Frontends\\WebApps\\Spintr.Site\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { Chart, registerables } from '../dist/chart.mjs';
Chart.register.apply(Chart, _toConsumableArray(registerables));
export default Chart;